import React, { useEffect } from 'react';
import PageHeader from '../innovher/PageHeader';
import { IMG } from '../../lib/images';
import SEO from '../SEO';

export default function VosaFuturepreneursPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    const els = document.querySelectorAll('.reveal-up');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  const gallery = [
    IMG.eventVosa1, // 0: 2x2
    IMG.eventVosa2, // 1: 2x1
    IMG.eventVosa3, // 2: 1x1
    IMG.eventVosa4  // 3: 1x1
  ];

  return (
    <>
      <SEO 
        title="VOSA Futurepreneurs | InnovHer Event"
        description="The Futurepreneurs Challenge empowers high school students in Jaipur with entrepreneurial skills and mentorship, hosted with InnovHer."
        keywords="VOSA Futurepreneurs, student entrepreneurs Jaipur, InnovHer events, Rajasthan youth entrepreneurship"
      />
      <PageHeader
        eyebrow="Signature Event"
        title={<>VOSA <span className="text-[#ff8ec5]">Futurepreneurs</span></>}
        subtitle="The Futurepreneurs Challenge 2024, held on November 8, 2024, at Maharana Pratap Auditorium, Jaipur, was a transformative event aimed at empowering high school students with entrepreneurial skills."
        image={IMG.eventVosa2}
        breadcrumbs={[{ label: 'Events', to: '#' }, { label: 'VOSA Futurepreneurs' }]}
      />

      <section className="relative bg-[#08080a] py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          
          <div className="reveal-up max-w-4xl mx-auto text-center mb-24">
            <h2 className="text-3xl md:text-5xl font-semibold tracking-tight text-white mb-8">Empowering Young Innovators</h2>
            <p className="text-lg text-white/60 leading-relaxed text-justify md:text-center">
              Bringing together over 400 attendees, 25 startups, and teams from 10+ schools, it provided a platform for young innovators to pitch creative ideas, connect with industry leaders, and receive mentorship. The event fostered collaboration within Rajasthan’s startup ecosystem and witnessed soft investment commitments for seven teams. With engaging sessions, impactful jury evaluations, and vibrant networking, the challenge celebrated innovation and inspired the next generation of entrepreneurs.
            </p>
          </div>

          <div className="reveal-up">
            <h3 className="text-2xl font-bold text-white mb-8 border-l-4 border-[#ff8ec5] pl-4">Event Gallery</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-4 auto-rows-[250px] md:auto-rows-[300px] gap-4 md:gap-6">
              {gallery.map((src, i) => {
                const getBentoClasses = (index) => {
                  switch(index) {
                    case 0: return "md:col-span-2 md:row-span-2";
                    case 1: return "md:col-span-2 md:row-span-1";
                    default: return "md:col-span-1 md:row-span-1";
                  }
                };
                
                return (
                <div key={i} className={`relative group rounded-3xl overflow-hidden bg-white/5 border border-white/10 ${getBentoClasses(i)}`}>
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors duration-500 z-10 pointer-events-none" />
                  <img 
                    src={src} 
                    alt={`VOSA Futurepreneurs Gallery ${i + 1}`} 
                    className="absolute inset-0 w-full h-full object-contain transform group-hover:scale-105 transition-transform duration-700" 
                    loading="lazy"
                  />
                </div>
              )})}
            </div>
          </div>

        </div>
      </section>
    </>
  );
}
